export const NAV_LINKS = [
  { name: "Home", href: "#hero" },
  { name: "WorkFlow", href: "#workflow" },
  { name: "Services", href: "#services" },
  { name: "Special Offer", href: "#offer" },
];

export const TECH_STACK = [
  {
    id: "db",
    title: "Databases",
    items: ["Oracle 19c–23c", "SQL Server", "PostgreSQL", "MySQL", "MariaDB"],
    focus: "Performance tuning, HA/RAC, Patching & Upgrades",
  },
  {
    id: "infra",
    title: "Core Infrastructure",
    items: ["Windows Server & AD", "VMware vSphere", "Intune & Entra ID", "Linux"],
    focus: "GPO, PKI, vCenter, Virtualization",
  },
  {
    id: "storage",
    title: "Storage & DR",
    items: ["HPE 3PAR", "Dell PowerStore", "Dell Unity/VPlex", "Hitachi"],
    focus: "Backup & Disaster Recovery solutions",
  }
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Join & Verify",
    description: "Enter our Discord. Our automated system assigns you a private client channel instantly."
  },
  {
    step: "02",
    title: "Open a Ticket",
    description: "Describe your issue or project. Use one of your 5 free tickets for immediate triage."
  },
  {
    step: "03",
    title: "Expert Resolution",
    description: "A specialist from our team takes the lead, providing direct updates until it's fixed."
  }
];

export const SOCIAL_LINKS = [
  { name: "LinkedIn", href: "https://www.linkedin.com/company/infratier/", icon: "Linkedin" },
  { name: "Facebook", href: "https://www.facebook.com/share/1XQKh3uHHF/?mibextid=wwXIfr", icon: "Facebook" },
  { name: "Discord", href: "https://discord.com/channels/1465996825680154667/1466002453689536524", icon: "MessageSquare" }
];

export const HASHTAGS = [
  "#ITServices", "#DatabaseAdministration", "#Infrastructure", 
  "#StorageSolutions", "#DisasterRecovery", "#Oracle", "#MariaDB"
];
export const CONTACT_INFO = {
  discord: "support@infra-tier.com",
  email: "support@infra-tier.com",
  tags: ["#ITServices", "#DatabaseAdministration", "#Infrastructure", "#StorageSolutions"]
};